import { render, staticRenderFns } from "./cascader-items.vue?vue&type=template&id=debbf1ce&scoped=true&"
import script from "./cascader-items.vue?vue&type=script&lang=js&"
export * from "./cascader-items.vue?vue&type=script&lang=js&"
import style0 from "./cascader-items.vue?vue&type=style&index=0&id=debbf1ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "debbf1ce",
  null
  
)

component.options.__file = "cascader-items.vue"
export default component.exports